import { create } from 'zustand';
import { getCreditListAction, setHasMoreDataAction } from './action';
import {
  CreditDataType,
  CreditRequestBodyType
} from '../../Types/credits.type';
import { OptionType } from '../../Types/common.type';

type CreditsType = {
  activeCreditListData: CreditDataType[];
  expiredCreditListData: CreditDataType[];
  usedCreditListData: CreditDataType[];
  creditsListLoading: boolean;
  creditsListError: boolean;
  getCreditListAction: (
    type: string,
    body: CreditRequestBodyType,
    changedFilter?: boolean
  ) => Promise<number>;
  hasMoreData: {
    active: boolean;
    expired: boolean;
    used: boolean;
  };
  setHasMoreDataAction: (hasMore: {
    active: boolean;
    expired: boolean;
    used: boolean;
  }) => void;
  dataLength: number;
  setDataLength: (dataLength: number) => void;
  selectedHistoryList: OptionType;
  setSelectedHistoryList: (list: OptionType) => void;
};

const useCreditsStore = create<CreditsType>((set) => ({
  activeCreditListData: [],
  expiredCreditListData: [],
  usedCreditListData: [],
  creditsListLoading: true,
  creditsListError: false,
  hasMoreData: {
    active: true,
    expired: true,
    used: true
  },
  dataLength: 10,
  selectedHistoryList: null,
  setSelectedHistoryList: (list) =>
    set({ selectedHistoryList: list, creditsListLoading: true }),
  setDataLength: (dataLength) => set({ dataLength }),
  getCreditListAction: (type, body, changedFilter) =>
    getCreditListAction(set, type, body, changedFilter),
  setHasMoreDataAction: (hasMore) => setHasMoreDataAction(set, hasMore)
}));

export default useCreditsStore;
